import React from 'react';
import { realCosts } from '../data/copy';
export function CostSection() {
  return <section className="defer-paint w-full bg-ivory py-12 sm:py-16" aria-labelledby="cost-heading" data-id="element-46" data-mp="9c6izcspilt0">
      <div className="mx-auto max-w-5xl px-6" data-id="element-47" data-mp="4kg18lrfwvrk">
        <h2 id="cost-heading" className="mx-auto max-w-2xl text-center font-display text-[2rem] leading-[1.12] text-ink sm:text-[2.6rem]" data-id="element-48" data-mp="4j4zsslgw03m">
          Planning from scratch isn’t free.{' '}
          <span className="text-terracotta" data-id="element-49" data-mp="3mqueeihvx1ow">You pay for it.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-x-10 gap-y-7 sm:grid-cols-2 lg:grid-cols-3" data-id="element-50" data-mp="3msxejvcr4b7c">
          {realCosts.map(cost => <li key={cost.label} data-id="element-51" data-mp="3ct6i3o4mrm4m">
              <span className="block h-px w-7 bg-terracotta/50" aria-hidden="true" data-id="element-52" data-mp="3cu7vhz94ckpi" />
              <h3 className="mt-3 font-display text-lg text-terracotta-deep" data-id="element-53" data-mp="1fy0pd9lnjlyy">
                {cost.label}
              </h3>
              <p className="mt-1 font-sans text-[0.88rem] leading-snug text-stone" data-id="element-54" data-mp="p7tkg9lzkkro">
                {cost.detail}
              </p>
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-lg text-center font-display text-xl leading-snug text-ink sm:text-2xl" data-id="element-55" data-mp="t6ty7dplwx7t">
          Your dedication is already there.{' '}
          <span className="text-terracotta" data-id="element-56" data-mp="k99xc5vnp2xq">The system isn’t.</span>
        </p>
      </div>
    </section>;
}